var impressum = "Impressum";
var privacy = "Privacy e note legali";
var recallInfo = "Informazioni sul richiamo";
var signOut = "Disconnetti";
var it_it = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { it_it as default, impressum, privacy, recallInfo, signOut };
